export default {
    cz: {
        eshop: 'Produkty',
        rental: 'Půjčovna',
        category: 'Kategorie',
        article: 'Články a dokumenty',
        document: 'Dokumenty',
        season: 'Produkty za věrnost',
    },
    sk: {
        eshop: 'Produkty',
        rental: 'Požičovňa',
        category: 'Kategórie',
        article: 'Články a dokumenty',
        document: 'Dokumenty',
        season: 'Produkty za vernosť',
    },
}
